import { idTypesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewIdType = (state = initialState, action) => {
  switch (action.type) {
    case idTypesConstants.VIEW_IDTYPE_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case idTypesConstants.VIEW_IDTYPE_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case idTypesConstants.VIEW_IDTYPE_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case idTypesConstants.VIEW_IDTYPE_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
